import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

import Navbar from './Navbar';

function LayoutPage() {
  // const queryEntries = useQuery(["entries", dataCompany.data.id], getEntries, {
  //   staleTime: Infinity,
  // });

  return (
    <Box
      className='LayoutPage'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100%',
        overflow: 'hidden',
      }}
    >
      <Navbar />

      <Box
        className='OutletDashboard'
        sx={{
          display: 'flex',
          flex: 1,
          overflow: 'hidden',
          background: 'linear-gradient(257.63deg, rgba(9, 153, 157, 0.25) -0.36%, rgba(59, 128, 177, 0.25) 14.31%, rgba(0, 36, 164, 0.25) 40.45%, rgba(169, 107, 231, 0.25) 88.1%, rgba(243, 72, 91, 0.25) 120.83%)',
          backgroundColor: '#8591bc40',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Outlet />
        </Box>
      </Box>

      {/* <MainOutletComponent><Outlet /></MainOutletComponent> */}
    </Box>
  );
}

export default LayoutPage;
